import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";

const dummyOptions = [
    { label: "Option 1", value: 1 },
    { label: "Option 2", value: 2 },
    { label: "Option 3", value: 3 }
];

export default function ReportTopFilters() {
    return (
        <div className="report-top">
            <div className="filter-row">
                <label>From Date</label>
                <Calendar
                    showIcon
                    dateFormat="dd/mm/yy"
                />

                <label className="to-label">To Date</label>
                <Calendar
                    showIcon
                    dateFormat="dd/mm/yy"
                />
            </div>

            <div className="filter-row full">
                <label>Style No</label>
                <MultiSelect
                    options={dummyOptions}
                    placeholder="Select Style"
                    display="chip"
                />
            </div>

            <div className="filter-grid">
                <MultiField label="Customer" />
                <MultiField label="Category" />
                <MultiField label="Metal" />
                <MultiField label="Gold Quality" />

                <div className="filter-item">
                    <label>Price</label>
                    <InputText />
                </div>

                <MultiField label="Diamond Shape" />
                <MultiField label="Diamond Quality" />
                <MultiField label="Item Size" />
                <MultiField label="Collection" />
            </div>

        </div>
    );
}

function MultiField({ label }) {
    return (
        <div className="filter-item">
            <label>{label}</label>
            <MultiSelect
                options={dummyOptions}
                placeholder={`Select ${label}`}
                display="chip"
            />
        </div>
    );
}
